import { FONT_BALOO_NAME, FONT_LATO_NAME } from './constats';

export const defaultTitleStyle = {
  fill: [0xfefefd, 0x9b7853],
  fontFamily: FONT_LATO_NAME,
  stroke: '#dec195',
  strokeThickness: 1,
  fontSize: 44,
  align: 'center',
  fontWeight: 900,
};

export const freeSpinTitleStyle = {
  ...defaultTitleStyle,
};

export const multiplierTitleStyle = {
  ...defaultTitleStyle,
};

export const freeSpinValueStyle = {
  fontFamily: FONT_BALOO_NAME,
  fontSize: 100,
  fill: [0xffffff, 0xc99bfc],
  align: 'center',
};

export const multiplierValueStyle = {
  fontFamily: FONT_BALOO_NAME,
  fontSize: 100,
  fill: [0xffffff, 0x9bfaf2],
  align: 'center',
};

const bonusBaseElementTextStyle = {
  fontFamily: FONT_BALOO_NAME,
  fontSize: 82,
  fontWeight: 900,
  lineJoin: 'round',
  strokeThickness: 6,
  miterLimit: 9,
};

export const bonusGreenElementTextStyle = {
  ...bonusBaseElementTextStyle,
  fill: [0xffffff, 0x82edc2],
  stroke: 0x458c6e,
};

export const bonusRedElementTextStyle = {
  ...bonusBaseElementTextStyle,
  fill: [0xffffff, 0xf8b4c8],
  stroke: 0xBA6775,
};

export const bonusBlueElementTextStyle = {
  ...bonusBaseElementTextStyle,
  fill: [0xffffff, 0xa5c0f2],
  stroke: 0x6472b5,
};

export const bonusActionStyle = {
  fontFamily: FONT_LATO_NAME,
  fontSize: 45,
  fontWeight: 900,
  fill: 0xFFFFFF,
  textAlign: 'center',
};

export const buyBonusTitleTextDefaultStyle = {
  fontFamily: FONT_LATO_NAME,
  fontSize: 52,
  fontWeight: 900,
  fill: 0xFFFFFF,
};

export const autoSpinCountTextStyle = {
  fontFamily: FONT_LATO_NAME,
  fontSize: 35,
  fontWeight: 900,
  fill: 0x000000,
};

export const buyBonusTitleTextStyle = {
  ...buyBonusTitleTextDefaultStyle,
};

export const buyBonusValueTextStyle = {
  ...buyBonusTitleTextDefaultStyle,
  fontFamily: FONT_BALOO_NAME,
  fontSize: 90,
};

export const winOddTextStyle = {
  fill: [0xffef00],
  fontWeight: 900,
  fillGradientStops: [.33, .80, 1],
  fontFamily: FONT_BALOO_NAME,
  stroke: 0xf6e2cd,
  strokeThickness: 1,
  fontSize: 140,
  align: 'center',
  dropShadow: true,
  dropShadowColor: 0x221605,
  dropShadowAlpha: .58,
  dropShadowAngle: Math.PI / 2,
  dropShadowBlur: 9,
  dropShadowDistance: 8,
};

export const bonusOddStyle = {
  fill: 0xEFC90B,
  fontWeight: 10,
  fillGradientStops: [.33, .80, 1],
  fontFamily: FONT_BALOO_NAME,
  stroke: 0x221605,
  strokeThickness: 1,
  fontSize: 50,
  align: 'center',
  dropShadow: true,
  dropShadowColor: 0x221605,
  dropShadowAlpha: .58,
  dropShadowAngle: Math.PI / 2,
  dropShadowBlur: 9,
  dropShadowDistance: 8,
};

export const amountTextStyle = {
  fill: [0xffffff, 0xb38758, 0xb58f66],
  fontWeight: 900,
  fillGradientStops: [.33, .80, 1],
  fontFamily: FONT_BALOO_NAME,
  stroke: 0xf6e2cd,
  strokeThickness: 1,
  fontSize: 120,
  align: 'center',
  dropShadow: true,
  dropShadowColor: 0x221605,
  dropShadowAlpha: .58,
  dropShadowAngle: Math.PI / 2,
  dropShadowBlur: 9,
  dropShadowDistance: 8,
};

export const congratulationsTitleStyle = {
  fill: 0xFFFFFF,
  fontWeight: 800,
  fillGradientStops: [.33, .80, 1],
  fontFamily: FONT_LATO_NAME,
  stroke: 0xf6e2cd,
  strokeThickness: 1,
  fontSize: 40,
  align: 'center',
};

export const congratulationsButtonStyle = {
  fill: 0xFFFFFF,
  fontWeight: 400,
  fillGradientStops: [.33, .80, 1],
  fontFamily: FONT_LATO_NAME,
  stroke: 0xf6e2cd,
  strokeThickness: 1,
  fontSize: 55,
  align: 'center',
};

export const betAmountValueTextStyle = {
  fill: 0xFFFFFF,
  fontFamily: FONT_LATO_NAME,
  fontSize: 25,
  fontWeight: 900,
};
